export const MooringProductionOrderEvents = {
  HOURS_ENTITY: 'mooring-production-order-hours',
};
